export default function toB2cUrl ({ mchWebSite, infoId, treeId }, x, y) {
  window.open(
    `http://${mchWebSite}/newb2c/productdetail/${infoId}?treeId=${treeId}`,
    '_blank',
    `top=${y + 20},left=${x - 187},width=375,height=667,fullscreen=1,menubar=0,resizable=0,toolbar=0,scrollbars=0,status=0,location=0,directories=0`
  )
}
